import { cn } from "../../lib/utils";

export function Divider({ className }: { className?: string }): JSX.Element {
  return <div className={cn("h-px w-full bg-slate-200", className)} />;
}
